<app-confirm-action-modal
  testId="stop-campaign-dialog"
  title="Stop Campaign?"
  confirmLabel="Yes, Stop Campaign"
  (confirm)="onConfirmStop()"
  (cancel)="onClose()"
>
  <div class="message-content">
    <p>
      Are you sure you want to stop this campaign? This will permanently stop the campaign and it
      cannot be resumed.
    </p>
  </div>
  <div class="info-box">
    <div class="info-content">
      <div class="info-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.166 2.78259C15.4229 3.50831 16.4685 4.5497 17.1992 5.80368C17.9299 7.05765 18.3205 8.48074 18.3322 9.93204C18.3439 11.3833 17.9764 12.8126 17.266 14.0782C16.5557 15.3438 15.5271 16.4019 14.2821 17.1479C13.037 17.8938 11.6188 18.3016 10.1678 18.331C8.71671 18.3603 7.28314 18.0102 6.00898 17.3153C4.73482 16.6204 3.66424 15.6047 2.90324 14.3689C2.14223 13.133 1.71719 11.7199 1.67018 10.2693L1.66602 9.99926L1.67018 9.72926C1.71685 8.29008 2.13564 6.88756 2.88572 5.65842C3.63579 4.42928 4.69156 3.41547 5.95009 2.71583C7.20862 2.01619 8.62697 1.65459 10.0669 1.66629C11.5067 1.67799 12.919 2.06259 14.166 2.78259ZM9.99935 9.16593H9.16602L9.06852 9.17176C8.8576 9.19684 8.66423 9.30152 8.5279 9.4644C8.39158 9.62728 8.32259 9.83606 8.33504 10.0481C8.34749 10.2601 8.44043 10.4594 8.59488 10.6052C8.74932 10.751 8.95362 10.8324 9.16602 10.8326V13.3326L9.17185 13.4301C9.19573 13.6328 9.29318 13.8197 9.44571 13.9553C9.59823 14.091 9.79524 14.1659 9.99935 14.1659H10.8327L10.9302 14.1601C11.1329 14.1362 11.3198 14.0388 11.4554 13.8862C11.5911 13.7337 11.666 13.5367 11.666 13.3326L11.6602 13.2351C11.6382 13.0491 11.5543 12.8759 11.4218 12.7434C11.2894 12.611 11.1162 12.527 10.9302 12.5051L10.8327 12.4993V9.99926L10.8268 9.90176C10.803 9.69905 10.7055 9.51215 10.553 9.37652C10.4005 9.24089 10.2035 9.16595 9.99935 9.16593ZM10.0077 5.83259L9.90185 5.83843C9.69094 5.86351 9.49756 5.96819 9.36124 6.13107C9.22491 6.29394 9.15592 6.50273 9.16837 6.71476C9.18082 6.9268 9.27376 7.12608 9.42821 7.27189C9.58266 7.41769 9.78695 7.49902 9.99935 7.49926L10.1052 7.49343C10.3161 7.46834 10.5095 7.36366 10.6458 7.20079C10.7821 7.03791 10.8511 6.82912 10.8387 6.61709C10.8262 6.40505 10.7333 6.20577 10.5788 6.05997C10.4244 5.91416 10.2201 5.83283 10.0077 5.83259Z"
            fill="#717683"
          />
        </svg>
      </div>
      <div class="info-text">
        <p>Note: This action will permanently stop the campaign and cannot be undone.</p>
      </div>
    </div>
  </div>
</app-confirm-action-modal>
